import React from 'react';
import Box from '@mui/material/Box';
import LaboxGC from 'icons/LaboxGC';
import { CircularProgress } from '@mui/material';
import Footer from './Footer';

export default function LoadingPage() {
  return (
    <Box
      sx={{
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <LaboxGC width="180" />
      <CircularProgress />
      <Footer minimal />
    </Box>
  );
}
